/** @format */

import React, { useState } from 'react'
import ModalTemplate from '../../../../Components/ModalTemplate/ModalTemplate'
import localize from '../../../../Global/Localize'
import FIleSelectLookup from '../../../../Components/Lookup/FIleSelectLookup'
import EmployeeLookup from '../../../../Components/Lookup/EmployeeLookup'
import Swal from 'sweetalert2'
import { toBase64 } from '../../../../Helpers/blobs'
import Loader from '../../../../Components/Loaders/Loader'
import { postData } from '../../../../Helpers/webApi'

function CreateDocument({ editMode, document, refreshDocuments, close }) {
  const [isBusy, setIsBusy] = useState(false)
  const [tempDoc, setTempDoc] = useState(document)

  async function createDocument() {
    setIsBusy(true)
    const { success } = await postData(
      '/employeeDocument/create',
      tempDoc,
      false
    )

    if (success) {
      Swal.fire('Operation Successful', 'Document Created', 'success')
      refreshDocuments()
      close()
    } else {
      Swal.fire('Error', 'Document Not Created!', 'error')
    }
    setIsBusy(false)
  }

  async function updateDocument() {
    setIsBusy(true)
    setIsBusy(false)
  }

  return (
    <ModalTemplate
      modalTitle="document"
      modalMode={localize(editMode ? 'edit' : 'create')}
      actionText={localize(editMode ? 'update' : 'create')}
      handleClose={
        isBusy
          ? () => {
              Swal.fire('Error', 'Sorry modal is Busy', 'error')
            }
          : close
      }
      handleAction={
        isBusy
          ? () => {
              Swal.fire('Error', 'Sorry modal is Busy', 'error')
            }
          : editMode
          ? updateDocument
          : createDocument
      }
      // hideFooter={isBusy}
    >
      {isBusy ? (
        <Loader />
      ) : (
        <>
          <div className="row">
            <div className="col d-flex align-items-center gap-2">
              <label htmlFor="" className="col-4 text-capitalize">
                {localize('document')}
              </label>
              <FIleSelectLookup
                accept=".pdf,application/pdf"
                displayValue={tempDoc?.fileName}
                onSelect={async f => {
                  setIsBusy(true)
                  let file = f.target.files[0]
                  let b64 = await toBase64(file)
                  setTempDoc({
                    ...tempDoc,
                    fileName: file?.name,
                    document: b64,
                  })
                  setIsBusy(false)
                }}
              />
            </div>
            <div className="col d-flex align-items-center gap-2">
              <label htmlFor="" className="col-4 text-capitalize">
                {localize('employee')}
              </label>
              <EmployeeLookup
                displayValue={tempDoc?.employeeCustomerFullName}
                onSelect={e =>
                  setTempDoc({
                    ...tempDoc,
                    employeeCustomerFullName: e?.customerFullName,
                    employeeId: e?.id,
                  })
                }
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col d-flex align-items-center gap-1">
              <label htmlFor="" className="col-2 text-capitalize">
                {localize('title')}
              </label>
              <input
                type="text"
                className="form-control"
                value={tempDoc?.fileTitle}
                onChange={e =>
                  setTempDoc({ ...tempDoc, fileTitle: e.target.value })
                }
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col d-flex  gap-1">
              <label htmlFor="" className="col-2 text-capitalize">
                {localize('description')}
              </label>
              <textarea
                cols="30"
                rows="10"
                className="form-control"
                value={tempDoc?.fileDescription}
                onChange={e =>
                  setTempDoc({ ...tempDoc, fileDescription: e.target.value })
                }
              ></textarea>
            </div>
          </div>
        </>
      )}
    </ModalTemplate>
  )
}

export default CreateDocument
